<div class="contentBlockerContainer"><div class="full-width"><slot></slot></div></div>